export type HeatmapFocusKey = "beat" | "close" | "lag";
export type HeatmapTileStatus = HeatmapFocusKey | "no_data";

export function tileBgColor(status: HeatmapTileStatus) {
  if (status === "no_data") {
    return "color-mix(in oklch, var(--card), var(--muted) 55%)";
  }

  // Uses theme CSS variables so colors stay identical in dark mode.
  if (status === "beat") return "var(--heat-green-bg)";
  if (status === "close") return "var(--heat-yellow-bg)";
  return "var(--heat-red-bg)";
}
